export default {"src":"/_next/static/media/bridgestone.04d8da3b.svg","height":62,"width":176,"blurWidth":0,"blurHeight":0};